import { useState, useRef } from 'react'
import classNames from 'classnames'
import { useClickAway } from 'react-use';
import { SalsaBadge } from './SalsaBadge.js'
import { SalsaImagePlaceholder } from './SalsaImagePlaceholder.js'

import {
    FacebookButton,
    LinkedInButton,
    TwitterButton,
    MailButton,
    LinkButton
} from '../../share-buttons/buttons.js'

const icons = {
    forward: (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" id="forward"
        className="fill-current w-3.5 h-3.5">
        <path
            d="M3.4 29h33.2c.9 0 1.3 1.1.7 1.7l-9.6 9.6c-.6.6-.6 1.5 0 2.1l2.2 2.2c.6.6 1.5.6 2.1 0L49.5 27c.6-.6.6-1.5 0-2.1L32 7.4c-.6-.6-1.5-.6-2.1 0l-2.1 2.1c-.6.6-.6 1.5 0 2.1l9.6 9.6c.6.7.2 1.8-.7 1.8H3.5c-.8 0-1.5.6-1.5 1.4v3c0 .8.6 1.6 1.4 1.6z">
        </path>
    </svg>),
    newWindow: (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" id="new_window" className="fill-current w-3.5 h-3.5"><g><path d="M48.7 2H29.6c-.8 0-1.6.5-1.6 1.3v3c0 .8.7 1.7 1.6 1.7h7.9c.9 0 1.4 1 .7 1.6l-17 17c-.6.6-.6 1.5 0 2.1l2.1 2.1c.6.6 1.5.6 2.1 0l17-17c.6-.6 1.6-.2 1.6.7v7.9c0 .8.8 1.7 1.6 1.7h2.9c.8 0 1.5-.9 1.5-1.7v-19c0-.9-.5-1.4-1.3-1.4z" /><path d="M36.3 25.5L32.9 29c-.6.6-.9 1.3-.9 2.1v11.4c0 .8-.7 1.5-1.5 1.5h-21c-.8 0-1.5-.7-1.5-1.5v-21c0-.8.7-1.5 1.5-1.5H21c.8 0 1.6-.3 2.1-.9l3.4-3.4c.6-.6.2-1.7-.7-1.7H6c-2.2 0-4 1.8-4 4v28c0 2.2 1.8 4 4 4h28c2.2 0 4-1.8 4-4V26.2c0-.9-1.1-1.3-1.7-.7z" /></g></svg>),
    play: (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" id="play" className="fill-current w-3.5 h-3.5"><path d="M8 43.7V8.3c0-1 1.3-1.7 2.2-.9l33.2 17.3c.8.6.8 1.9 0 2.5L10.2 44.7c-.9.7-2.2.1-2.2-1z"></path></svg>)
}

export const SalsaCard = (props) => {
    const [showShareButtons, setShowShareButtons] = useState(false)
    const ref = useRef(null);
    useClickAway(ref, () => {
        setShowShareButtons(false)
    });
    return (<div
        className="border grid items-stretch overflow-hidden rounded-md shadow content-between"
        id={props.id}
        ref={props.ref}
    >
        <div>
            {props.type !== "external-links"
                ? <a href={props.href} className="block aspect-w-16 aspect-h-9">
                    {
                        props.image.src
                            ? <img src={props.image.src} alt={props.image.alt} className="object-cover w-full" />
                            : <SalsaImagePlaceholder className="object-cover w-full bg-navy" />
                    }
                </a>
                : null
            }
            <div className="grid content-start p-4 pb-0 gap-3">
                <div className="content-between flex justify-between max-w-full overflow-hidden w-full">
                    <a href={props.href}>
                        <h3 className="font-semibold text-blue text-xl">{props.title}</h3>
                    </a>
                    {props.titleImage && (
                        <div class="max-h-12 ml-4" style={{ maxWidth: '6rem' }}>
                            <img src={props.titleImage} alt={props.title} className="border-0 h-full object-contain object-right w-full max-h-16" />
                        </div>
                    )}
                </div>
                {

                    props?.badge?.label?.length > 0 && (
                        <div className='max-w-full overflow-hidden w-full'>
                            <SalsaBadge label={props.badge.label} />
                        </div>
                    )
                }
                <div>
                    {
                        props.eventDetails
                            ? (
                                <ul>
                                    <li>Category: Webinar</li>
                                    <li>When: May 13 @ 1:00 pm - 2:00 pm EDT</li>
                                    <li>Where: Zoom</li>
                                </ul>
                            )
                            : null
                    }
                </div>
                <div>
                    {props.body}
                </div>
            </div>
        </div>
        <div className="grid gap-2 p-4 pt-0 self-end">
            <a href={props.href}
                className="text-blue text-base inline-grid gap-2 grid-col-2-maxcontent items-center">
                {props.linkIcon && props.linkIconPosition === 'left' ? icons[props.linkIcon] : null}
                <span>{props.linkLabel}</span>
                {props.linkIcon && props.linkIconPosition !== 'left' ? icons[props.linkIcon] : null}
            </a>



            <div className="relative" ref={ref}>
                <div className={classNames(
                    'absolute bg-white border border-gray-200 p-4 rounded-lg shadow-md wp-block-salsa-blocks-share-buttons',
                    { 'hidden': !showShareButtons }
                )} style={{
                    bottom: '32px'
                }}>
                    <ul className="wp-block-social-links m-0" >
                        <LinkedInButton url={props.href} />
                        <FacebookButton url={props.href} />
                        <TwitterButton url={props.href} />
                        <MailButton url={props.href} subject={props.title} />
                        <LinkButton url={props.href} />
                    </ul>
                </div>
                <button className="text-blue text-base inline-grid gap-2 grid-col-2-maxcontent items-center" onClick={() => { setShowShareButtons(showShareButtons => !showShareButtons) }}>

                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" id="socialshare"
                        className="fill-current w-3.5 h-3.5">
                        <path
                            d="M40.9 32c-2.6 0-4.9 1.1-6.5 2.8l-14.6-7.3c.1-.5.1-1 .1-1.6 0-.5-.1-1.1-.1-1.6L34.4 17c1.6 1.8 4 2.9 6.6 2.9 5 0 9-4 9-9s-4-9-9-9-9 4-9 9v.6l-15.1 7.6c-1.7-1.3-3.7-2.1-6-2.1-5 0-9 4-9 9s4 9 9 9c2.3 0 4.3-.8 5.9-2.2l15.1 7.5v.7c0 5 4 9 9 9s9-4 9-9-4-9-9-9z">
                        </path>
                    </svg>
                    <span>Share</span>
                </button>


            </div>


        </div>
    </div>
    )
}

export default SalsaCard